import { render, staticRenderFns } from "./select-article-win.vue?vue&type=template&id=2226ef97&"
import script from "./select-article-win.vue?vue&type=script&lang=js&"
export * from "./select-article-win.vue?vue&type=script&lang=js&"
import style0 from "./select-article-win.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2226ef97', component.options)
    } else {
      api.reload('2226ef97', component.options)
    }
    module.hot.accept("./select-article-win.vue?vue&type=template&id=2226ef97&", function () {
      api.rerender('2226ef97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/components/select-article-win.vue"
export default component.exports